import { FlyerCategories } from '@/types/flyer';

import artsIcon from '@/assets/categories/community/arts-dark.svg';
import graduationCapIcon from '@/assets/categories/community/graduation-cap-dark.svg';
import darkIcon from '@/assets/categories/community/lamp-dark.svg';
import sportsIcon from '@/assets/categories/community/sports-dark.svg';
import healthIcon from '@/assets/categories/community/health-dark.svg';
import familyIcon from '@/assets/categories/community/family-dark.svg';
import serviceLearningIcon from '@/assets/categories/community/service-learning-dark.svg';
import youthOrgsIcon from '@/assets/categories/community/youth-organizations.svg';
import recAndDiscoveryIcon from '@/assets/categories/community/recreation-and-discovery.svg';
import { CategoryId } from '@/config/constants';

export const communityCategories: FlyerCategories = [
  {
    id: CategoryId.Academics,
    title: 'Academics',
    icon: darkIcon,
  },
  {
    id: CategoryId.Sports,
    title: 'Sports',
    icon: sportsIcon,
  },
  {
    id: CategoryId.ArtsAndCulture,
    title: 'Arts & Culture',
    icon: artsIcon,
  },
  {
    id: CategoryId.CollegeAndCareer,
    title: 'College & Career',
    icon: graduationCapIcon,
  },
  {
    id: CategoryId.RecreationAndDiscovery,
    title: 'Recreation & Discovery',
    icon: recAndDiscoveryIcon,
  },
  {
    id: CategoryId.HealthAndSafety,
    title: 'Health & Safety',
    icon: healthIcon,
  },
  {
    id: CategoryId.VolunteerAndLocalService,
    title: 'Volunteer & Local Service',
    icon: serviceLearningIcon,
  },
  {
    id: CategoryId.FamilySupport,
    title: 'Family Support',
    icon: familyIcon,
  },
  {
    id: CategoryId.YouthOrganizations,
    title: 'Youth Organizations',
    icon: youthOrgsIcon,
  },
];
